import useGDPRConsent from "services/context/gdprContext"

export default function CookiesBanner() {
  const { consentDialog } = useGDPRConsent()
  return consentDialog
}
